import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';
import { SiteDashboardService } from 'src/app/home/site-dashboard/site-dashboard.service';

@Component({
	selector: 'app-truck-utilization-score',
	templateUrl: './truck-utilization-score.component.html',
	styleUrls: ['./truck-utilization-score.component.css']
})
export class TruckUtilizationScoreComponent implements OnChanges {
	@Input() devices: any = {};
	@Input() data: any = {};
	@Input() selectedDaysFilter: string = '';
	@Input() selectedPeriod: string = '';
	@Input() selectedBatteryVintage: string[] = ['all'];
	@Input() selectedTruckType = "All";
	@Input() truckManufacturer = "All";
	utilizationScoreSelectedData = [];
	energyScoreSelectedData = [];
	showData: boolean = true;

	truckDeviceType = DeviceFactory.types.iotah;
	allDevices: any = {};
	filteredDevices: any = {};
	constructor(
		private siteDashboardService: SiteDashboardService,
	) {}
	
	ngOnChanges(changes: SimpleChanges) {
		if (changes['devices'] && this.devices) {
			this.allDevices = { ...this.devices };
		}

		if (changes['selectedPeriod'] || changes['selectedDaysFilter'] || changes['truckManufacturer'] || changes['selectedTruckType'] || changes['selectedBatteryVintage']){
			this.updateSelectedData();
		}
	}

	ngOnInit() {
		this.updateSelectedData();
	}

	updateSelectedData() {
		const selectedData = this.data?.[this.selectedPeriod]?.[this.selectedDaysFilter];
		this.utilizationScoreSelectedData = [];
		this.energyScoreSelectedData = [];

		this.showData = true;
		//filter devices based on selected period
		const macAddressSet = new Set((selectedData?.devicesUsageScore || []).map(d => d.macAddress));
		this.filteredDevices = Object.entries(this.allDevices).reduce((acc, [mac, value]) => {
			if (macAddressSet.has(mac)) {
				acc[mac] = value;
			}
			return acc;
		}, {} as any);

		const usageScoreMap = new Map(
			(selectedData?.devicesUsageScore || []).map(device => [device.macAddress, device])
		);

		for (const macAddress in this.filteredDevices) {
			if (!this.isIncludedDevice(macAddress)) 
				continue;

			const usageScore: {score?: number, energy_score?: number} = usageScoreMap.get(macAddress);

			this.utilizationScoreSelectedData.push({
				macAddress,
				score: usageScore?.score ?? 0
			});

			this.energyScoreSelectedData.push({
				macAddress,
				energy_score: usageScore?.energy_score ?? 0
			});
		}
			if(!this.utilizationScoreSelectedData.length && !this.energyScoreSelectedData.length)
				this.showData = false;
	}
	isIncludedDevice(macAddress: string) {
		if (this.selectedTruckType !== 'All' && this.filteredDevices?.[macAddress]?.truck_type !== this.selectedTruckType)
			return false;

		if (!this.siteDashboardService.isVintageWithinFilter(this.filteredDevices?.[macAddress], this.selectedBatteryVintage))
			return false;

		if (this.truckManufacturer !== 'All' && this.filteredDevices?.[macAddress]?.truck_manufacturer !== this.truckManufacturer)
			return false;

		return true;
	}
}
